export default __webpack_public_path__ + "static/media/karta-x.76d56e4f.png";